import {
  Edit,
  SimpleForm,
  BooleanInput,
  NumberInput,
  TextInput
} from 'react-admin';
import { BackButton } from '../../../helperComponents/BackButton';
import { AdsWriteSettingsToolbar } from './components/AdsWriteSettingsToolbar';
import { nonNegative, perRun, ttlHours } from '../../../../helpers/adsWriteSettingsValidators';

export const AdsWriteSettingsEdit = (props) => {
  return (
    <>
      <BackButton path="/ads_write_settings" />
      <span className="h4">Edit Safety Limits</span>
      <Edit {...props} title=" " redirect={false} mutationMode="pessimistic">
        <SimpleForm toolbar={<AdsWriteSettingsToolbar />}>
          <BooleanInput
            source="kill_switch"
            label="Kill Switch"
            helperText="On = no script receives any action"
          />
          <BooleanInput
            source="preview_mode"
            label="Preview Mode"
            helperText="On = scripts only log what they would do"
          />
          <NumberInput source="max_budget_change_pct" label="Max Budget Change %" validate={nonNegative} />
          <NumberInput source="max_bid_change_pct" label="Max Bid Change %" validate={nonNegative} />
          <NumberInput
            source="max_actions_per_account_per_day"
            label="Max Actions Per Account Per Day"
            validate={nonNegative}
          />
          <NumberInput source="max_actions_per_run" label="Max Actions Per Run" validate={perRun} />
          <NumberInput source="approval_ttl_hours" label="Approval TTL Hours" validate={ttlHours} />
          <TextInput source="updated_by" label="Updated By" disabled />
          <TextInput source="updated_at" label="Updated At" disabled />
        </SimpleForm>
      </Edit>
    </>
  );
};
